import { Controller } from "stimulus"

export default class extends Controller {

  clear(e){
    const mainDiv = e.target.closest(".flatpickr")
    const input1 = mainDiv.getElementsByClassName("form-control bootstrap-datepicker input")[0]
    const input2 = mainDiv.getElementsByClassName("form-control bootstrap-datepicker flatpickr-input")[0]
    input1.value = ""
    input2.value = ""
  }

}
